export const CONSTANTS = {
  EXPIRED_COOKIE_IN_MINUTE: 30,
  STEP_NAME_PAGE: 1,
  STEP_MULTIPLE_QUESTION: 9,
  STEP_INPUT_FORM: 12,
  STEP_RESULT: 13,
  ID_ANSWER_ITEM_ONLY_ME: 10,
  INDEX_QUESTION_HAS_ANSWER_INPUT: 8,
}
